<template>
  <router-link :to="routeLink">
    <div class="profile" :style="{backgroundImage: `url(${article.thumbnail_image_url})`}">
      <div class="profile-bar flex" :class="profileBarClass">
        <div class="profile-name">
          <p class="body-4">{{ article.first_name }} {{ article.last_name }}</p>
        </div>
      </div>
      <div class="overlay" :class="categorySlug"></div>
    </div>
  </router-link>
</template>

<script>
  export default {
    name: 'PlayerProfileLink',

    props: {
      article: {
        default: null,
        type: Object
      },
      showArticleCategoryIcon: {
        default: true,
        type: Boolean
      }
    },

    data() {
      return {
        ADMIN_API_HOST: process.env.VUE_APP_ADMIN_HOST,
      }
    },

    computed: {
      categorySlug: function () {
        if (this.article.categories.length) {
          return this.article.categories[0].slug;
        }

        return 'default';
      },

      profileBarClass: function() {
        return {
          [this.categorySlug]: true,
          featured: this.showArticleCategoryIcon
        }
      },

      routeLink: function () {
        return {
          name: 'article',
          params: {
            category: this.categorySlug,
            article: this.article.slug,
          }
        };
      }
    }
  }
</script>

<style lang="scss" scoped>
  .profile {
    position: relative;
    background-size: cover;
    background-position: center center;
    height: 200px;

    .profile-bar {
      padding-top: 5px;
      pointer-events: none;
      width: 220px;
      height: 48px;
      bottom: config('negativeMargin.3');
      @apply justify-between pin-l z-10 absolute;

      &.craft {
        background: no-repeat url('~@/assets/images/craft-category-bar.svg');

        &.featured {
          background: no-repeat url("~@/assets/images/craft-category-featured-carousel-bar.svg");
        }
      }

      &.build {
        background: no-repeat url('~@/assets/images/build-category-bar.svg');

        &.featured { 
          background: no-repeat url("~@/assets/images/build-category-featured-carousel-bar.svg");
        }
      }

      &.experiment {
        background: no-repeat url('~@/assets/images/experiment-category-bar.svg');

        &.featured {
          background: no-repeat url("~@/assets/images/experiment-category-featured-carousel-bar.svg");
        }
      }

      &.eat {
        background: no-repeat url('~@/assets/images/eat-category-bar.svg');

        &.featured { 
          background: no-repeat url("~@/assets/images/eat-category-featured-carousel-bar.svg");
        }
      }

      &.celebrate {
        background: no-repeat url('~@/assets/images/celebrate-category-bar.svg');

        &.featured {
          background: no-repeat url("~@/assets/images/celebrate-category-featured-carousel-bar.svg");
        }
      }

      &.default {
        background: no-repeat url('~@/assets/images/craft-category-bar.svg');

        &.featured {
          background: no-repeat url("~@/assets/images/craft-category-featured-carousel-bar.svg");
        }
      }
    }

    .profile-name {
      width: 175px;

      p {
        @apply text-white ml-3 my-0 leading-none;
      }
    }

    .overlay {
      height: 200px;
      position: absolute;
      width: 100%;

      &:hover {
        transition: background-color .25s ease;

        &.craft {
          @apply bg-c1-c;
        }

        &.build {
          @apply bg-c2-c;
        }

        &.experiment {
          @apply bg-c3-c;
        }

        &.eat {
          @apply bg-c4-c;
        }

        &.celebrate {
          @apply bg-c5-c;
        }
      }
    }
  }
</style>
